import Cookies from "universal-cookie"

export default function setCurrencyCookie(currency: string) {
    const cookie = new Cookies();

    const expireYear = new Date();
    expireYear.setFullYear(expireYear.getFullYear() + 30);
    cookie.set('currency', currency, {path: '/', expires: expireYear})
}